/* eslint object-curly-newline:0 */
import Vue from 'vue';
import Vuex from 'vuex';
import { FoldersApi } from '../../api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    folders: [],
  },
  mutations: {
    SET_FOLDER(state, folder) {
      state.folders = folder;
    },
  },
  actions: {
    GET_FOLDERS({ commit }) {
      FoldersApi.getFolders()
        .then((resp) => {
          commit('SET_FOLDER', resp.data);
        });
    },
  },
});
